export const parse = (str: string) => {
  try {
    return JSON.parse(str);
  } catch {
    return {};
  }
};
